import * as React from "react";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import DownArrow from "../DownArrow";
import DialplanNode from "./DialplanNode";
import TtsAnnounce from "./TtsAnnounce";

function MarkAsAnswered() {
  return (
    <>
      <Grid container direction={"column"}>
        <Grid item xs={12}>
          <div style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}>
            <Typography variant="h6" align="left">
              ✅ Segna come risposta
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }} justifyContent="flex-start">
          <Typography variant="body" display={"inline"}>
            Segna questa chiamata come risposta, anche se non viene inoltrata ad un collaboratore.
          </Typography>
        </Grid>
      </Grid>
      <DownArrow/>
      <DialplanNode prop="next"/>
    </>
  );
}

MarkAsAnswered.description = "Segna la chiamata come risposta nell'applicazione, anche se non viene risposta da un operatore";
MarkAsAnswered.title = "Segna come risposta";
MarkAsAnswered.default = {
  type: "MARK_AS_ANSWERED",
  next: TtsAnnounce.default,
};
MarkAsAnswered.isAdvanced = true;

export default MarkAsAnswered; 